import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';


class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: [],
      dotPages: [],
    };
  };

  componentDidMount() {
    this.setPaginationState();
  };

  componentDidUpdate() {
    this.setPaginationState();
  };

  addPaginationDots(pages) {
    // Cribbed from https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
    var c = this.props.query.page;
    var m = pages.length;

    var current = c,
        last = m,
        delta = 1,
        left = current - delta + 1, // change to 'left = current - delta,' to show at most 6 items
        right = current + delta + 1,
        range = [],
        rangeWithDots = [],
        l;

    for (let i = 1; i <= last; i++) {
        if (i == 1 || i == last || i >= left && i < right) {
            range.push(i);
        }
    }

    for (let i of range) {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    }

    return rangeWithDots;
  }

  setPaginationState() {
    if (this.props.response !== null) {
      let pageCount = Math.ceil(this.props.response.totalPosts / this.props.pagination.perPage);
      let pages = _.cloneDeep(this.state.pages);
      let currentDotPages = _.cloneDeep(this.state.dotPages);

      if (pages.length !== pageCount) {
        pages = [];
        for (let i=0; i<pageCount; i++) {
          pages.push(i+1);
        }
      }

      let dotPages = this.addPaginationDots(pages);

      let checkDotPagesStateEquivalence = function() { // Ensure dotPages and this.state.dotPages are identical by looping through their contents and checking each value.
        // Create an array of 0s for each item in dotPages
        let arr = [];
        for (let i=0; i<dotPages.length; i++) {
          arr.push(0);
        }
        
        // Now loop through dotPages and see if individual values match this.state.dotPages
        for (let i=0; i<dotPages.length; i++) {
          if (dotPages[i] === this.state.dotPages[i]) {
            arr[i] = 1;
          }
        }

        if (arr.indexOf(0) === -1) {
          return false;
        }
        else {
          return true;
        }
      }.bind(this);

      if (checkDotPagesStateEquivalence()) {
        this.setState({
          pages: pages,
          dotPages: dotPages,
        });
      }
    }
  };

  render() {
    if (this.props.response.totalPosts <= this.props.pagination.perPage) {
      return null;
    }
    else {
      return (
        <nav className="Pagination">
          <ul>
            <li className={(this.props.query.page === 1) ? 'Pagination__prev  Pagination__prev--disabled' : 'Pagination__prev'}>
              <button onClick={function(e) { this.props.paginationClick(this.props.query.page - 1); }.bind(this)}>Previous</button>
            </li>
            {this.state.dotPages.map((pageNum, index) => // Loop through pets and display them
              <li key={index} className={(this.props.query.page === pageNum) ? 'Pagination__page  Pagination__page--current' : 'Pagination__page'}>
                {(pageNum === '...') && (
                  <span className="Pagination__dots">{pageNum}</span>
                )}
                {(pageNum !== '...') && (
                  <button onClick={function(e) { this.props.paginationClick(pageNum); }.bind(this)}>
                    {pageNum}
                  </button>
                )}
              </li>
            )}
            <li className={(this.props.query.page === this.state.pages.length) ? 'Pagination__next  Pagination__next--disabled' : 'Pagination__next'}>
              <button onClick={function(e) { this.props.paginationClick(this.props.query.page + 1); }.bind(this)}>Next</button>
            </li>
          </ul>
        </nav>
      );
    }
  };
};

Pagination.propTypes = {
  pagination: PropTypes.object,
  paginationClick: PropTypes.func,
  query: PropTypes.object,
  response: PropTypes.object,
  wpData: PropTypes.object,
};

export default Pagination;


// WEBPACK FOOTER //
// ./src/components/Pagination.js